var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"views-list"},_vm._l((_vm.views),function(views,index){return _c('md-list-item',{key:index,on:{"click":function($event){return _vm.setView(views)}}},[_vm._v("\n      "+_vm._s(views.title)+"\n  ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }